import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	async getPlants() {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plant`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getCommCodes(param) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${param.plantCd}/commonCodes?commCdType=${param.codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getGroups({ searchParams, currentPage = 1, pageUnit = 10 }) {
		let queryStr = '';

		if (searchParams.permGrpCd !== undefined || searchParams.userGrpName !== undefined || searchParams.useYn !== undefined) {
			queryStr = objectToQuerystring({
				permGrpCd: searchParams.permGrpCd,
				userGrpName: searchParams.userGrpName,
				useYn: searchParams.useYn,
				currentPage,
				pageUnit
			});
		}
		try {
			const response = await client.get(`${BASE_URL}/userGroup/v1/plants/${searchParams.plantCd}/groups${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async postGroups(param) {
		try {
			const response = await client.post(`${BASE_URL}/userGroup/v1/status/${param.status}/plants/${param.plantCd}/groups`, param.data);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
